import React from 'react';
import styled from 'styled-components';


const CwCredits = styled.div<{
  color: string,
}>`
  color: ${({ color }) => color};
  display: flex;
  align-items: center;
`;

const Link = styled.a<{
  color: string,
  hoverColor: string,
  transitionSettings: string,
}>`
  display: flex;
  align-items: center;
  color: ${({ color }) => color};
  text-decoration: none;
  transition: color ${({ transitionSettings }) => transitionSettings};
  
  &:hover{
    color: ${({ hoverColor }) => hoverColor};
    text-decoration: none !important;
    
    .wombatLogoBodyColor{
      fill: ${({ hoverColor }) => hoverColor};
    }
  }
`;

const StyledPath = styled.path<{ fillColor: string }>`
  fill: ${({ fillColor }) => fillColor};
`;

const CwCreditsLogo = styled.svg<{
  transitionSettings: string,
}>`

  transform: translateY(-0.1em);
  margin-right: 0.1em;
  margin-left: 0.2em;
  
  ${StyledPath} {
    transition: fill ${({ transitionSettings }) => transitionSettings};
  }
`;

interface IProp {
  primaryColor?: string,
  primaryColorOnHover?: string,
  transitionSettings?: string,
  className?: string,
}

const SvgSmallWombatLogo = ({
  primaryColor = '#000',
  primaryColorOnHover = '#4196b4',
  transitionSettings = '160ms ease-in-out',
  className,
}: IProp) => (
  <CwCredits
    color={primaryColor}
    className={className}
  >
    <Link
      href="https://commonwombat.pl"
      target="_blank"
      rel="nofollow noopener noreferrer"
      color={primaryColor}
      hoverColor={primaryColorOnHover}
      transitionSettings={transitionSettings}
    >
      <CwCreditsLogo
        transitionSettings={transitionSettings}
        width={51}
        height={28}
        viewBox="0 0 51 28"
      >
        <StyledPath
          fillColor={primaryColor}
          className="wombatLogoBodyColor"
          d="M32.67 18.856l.31.277c-.378.345-.777.517-1.199.517a1.57 1.57 0 01-1.152-.477 1.57 1.57 0 01-.477-1.153c0-.45.159-.833.476-1.153.318-.319.703-.478 1.153-.478.422 0 .821.172 1.2.516l-.31.281c-.285-.252-.581-.378-.89-.378-.333 0-.619.118-.856.355a1.166 1.166 0 00-.356.857c0 .337.118.623.356.86.237.236.523.355.856.355.309 0 .605-.126.89-.379zM36.216 16.861c.319.32.478.705.478 1.155 0 .451-.16.836-.478 1.155-.32.32-.704.479-1.155.479-.45 0-.836-.16-1.155-.479a1.574 1.574 0 01-.479-1.155c0-.45.16-.835.479-1.154.32-.32.704-.48 1.155-.48.45 0 .836.16 1.155.48zM35.06 16.8c-.337 0-.623.118-.86.356a1.172 1.172 0 00-.357.86c0 .337.119.624.357.862s.525.357.86.357c.336 0 .623-.119.86-.357.238-.238.357-.525.357-.861 0-.337-.119-.624-.356-.861a1.173 1.173 0 00-.861-.356zM37.719 16.425l1.035 1.789 1.031-1.79h.377v3.192h-.413V17.31l-.995 1.723-1-1.723v2.306h-.412v-3.191h.377zM41.334 16.425l1.035 1.789 1.031-1.79h.377v3.192h-.413V17.31l-.995 1.723-1-1.723v2.306h-.413v-3.191h.378zM47.211 16.861c.32.32.48.705.48 1.155 0 .451-.16.836-.48 1.155-.319.32-.704.479-1.154.479-.451 0-.836-.16-1.155-.479a1.574 1.574 0 01-.48-1.155c0-.45.16-.835.48-1.154.319-.32.704-.48 1.154-.48.451 0 .836.16 1.155.48zm-1.154-.061c-.337 0-.624.118-.861.356a1.172 1.172 0 00-.356.86c0 .337.119.624.357.862s.524.357.86.357c.336 0 .623-.119.86-.357.238-.238.356-.525.356-.861 0-.337-.118-.624-.356-.861a1.172 1.172 0 00-.86-.356zM48.24 16.425h.378l1.316 2.277v-2.277h.415v3.19h-.361l-1.334-2.305v2.306h-.413v-3.191zM25.075 26.704v-4.093h.652v4.093a.678.678 0 00.592.327.67.67 0 00.484-.199.647.647 0 00.204-.48v-3.74h.655v3.765a1.29 1.29 0 01-.394.913 1.29 1.29 0 01-.95.396c-.369 0-.674-.13-.915-.39-.244.26-.55.39-.92.39a1.28 1.28 0 01-.946-.396 1.266 1.266 0 01-.393-.913v-3.766h.65v3.741c0 .187.07.347.205.48a.67.67 0 00.485.2c.189 0 .35-.065.484-.195a.613.613 0 00.107-.133zM32.783 23.3c.504.503.755 1.11.755 1.821 0 .711-.251 1.319-.755 1.822a2.482 2.482 0 01-1.821.755 2.483 2.483 0 01-1.822-.755 2.482 2.482 0 01-.755-1.822c0-.71.252-1.318.755-1.822a2.482 2.482 0 011.822-.755c.71 0 1.318.252 1.821.755zm-1.821-.098c-.53 0-.983.187-1.358.561a1.85 1.85 0 00-.562 1.358c0 .53.188.984.564 1.36.375.375.827.563 1.356.563.53 0 .983-.188 1.357-.564.375-.375.562-.828.562-1.359 0-.53-.187-.983-.562-1.357a1.85 1.85 0 00-1.357-.562zM35.156 22.61l1.633 2.823 1.627-2.823h.595v5.035h-.652v-3.638l-1.57 2.719-1.576-2.719v3.637h-.651V22.61h.594zM41.128 22.61c.291 0 .541.104.749.31.207.207.311.456.311.748 0 .3-.15.485-.453.557.218.031.466.186.744.465.278.28.417.665.417 1.158 0 .493-.173.919-.519 1.277-.325.338-.651.51-.979.513v.007h-1.29V22.61h1.02zm-.368.652v.796h.425a.404.404 0 00.248-.11.362.362 0 00.114-.28.39.39 0 00-.118-.291.413.413 0 00-.3-.115h-.37zm0 1.466v2.262h.639v-.01c.134-.008.3-.116.5-.323.22-.227.33-.496.33-.809 0-.308-.11-.572-.329-.791a1.079 1.079 0 00-.79-.329h-.35zM45.489 22.61l1.83 5.035h-.691l-.649-1.781h-1.334L44 27.644h-.695l1.831-5.034h.353zm.254 2.602l-.43-1.18-.428 1.18h.858zM49.233 23.262v4.383h-.655v-4.383h-1.173v-.652h3.001v.652h-1.173zM4.46 21.648l2.158-2.138.007.007a1.847 1.847 0 10-.256-.264l.025.024L4.2 21.46l.26.187zM21.666 21.654l-2.157-2.138-.007.007a1.847 1.847 0 11.256-.264l-.024.023 2.193 2.185-.26.187z"
        />
        <StyledPath
          fillColor={primaryColor}
          className="wombatLogoBodyColor"
          d="M22.019 5.335l1.126-3.277L20.264.013l-.044.032V5.29L5.888 5.268V.031L5.844 0 3.016 2.058l1.068 3.257L0 18.45l3.976 2.852 2.045-2.021a2.426 2.426 0 01-.325-1.163 2.115 2.115 0 112.115 2.115c-.41 0-.856-.167-1.18-.369l-1.963 1.934 8.26 5.923V24.6l-2.92-2.06 1.204-3.503h3.68l1.163 3.49-2.841 2.067v3.102l8.194-5.952-1.918-1.889c-.324.203-.77.37-1.18.37a2.115 2.115 0 112.115-2.115c0 .395-.136.845-.325 1.162l1.996 1.973 4.207-3.056L22.02 5.335z"
        />
      </CwCreditsLogo>
    </Link>
  </CwCredits>
);

export default SvgSmallWombatLogo;
